// @flow
import { persistentFiltersReducer } from "./reducers/persistentFiltersReducer";
import { stockForecastTooltipReducer } from "./reducers/stockForecastTooltipReducer";
import { stockStatusTableFiltersReducer } from "./reducers/stockStatusTableFiltersReducer";
import { stockStatusFiltersReducer } from "./reducers/stockStatusFiltersReducer";
import { resourceEditFiltersReducer } from "./reducers/resourceEditFiltersReducer";
import { translationsMaterialsReducer } from "./reducers/translationsMaterialsReducer";

import type { PayloadAction } from "./types.tsx";
import type { StockStatusTableFiltersState } from "./reducers/stockStatusTableFiltersReducer";
import type { StockForecastTooltipState, StockForecastTooltipActions } from "./reducers/stockForecastTooltipReducer";
import type { SubcontractingModalState } from "./types.tsx";
import type { PersistentFiltersState } from "../redux/reducers/persistentFiltersReducer";
import type { TranslationsMaterialsState } from "./reducers/translationsMaterialsReducer";

export const SET_SUBCONTTRACTING_MODAL_ACTION_NAME: "set_subcontracting_modal" = "set_subcontracting_modal";
export const RESET_SUBCONTTRACTING_MODAL_ACTION_NAME: "reset_subcontracting_modal" = "reset_subcontracting_modal";
export type SetSubcontractingModalAction = PayloadAction<
    typeof SET_SUBCONTTRACTING_MODAL_ACTION_NAME,
    SubcontractingModalState,
>;
export type ResetSubcontractingModalAction = PayloadAction<
    typeof RESET_SUBCONTTRACTING_MODAL_ACTION_NAME,
    typeof undefined,
>;

export type ActionTypes = SetSubcontractingModalAction | ResetSubcontractingModalAction;

const initialStockStatusSubcontractingModal: SubcontractingModalState = {
    show: false,
    external_operation_id: "",
    quantity_total: "",
};

const initialState = {
    subcontracting_modal: initialStockStatusSubcontractingModal,
};

const subcontractingModalReducer = (state = initialState.subcontracting_modal, action) => {
    let new_state = state;

    // $FlowFixMe
    switch (action.type) {
        case SET_SUBCONTTRACTING_MODAL_ACTION_NAME:
            // $FlowFixMe
            new_state = { ...state, ...action.data };
            break;
        case RESET_SUBCONTTRACTING_MODAL_ACTION_NAME:
            new_state = initialState.subcontracting_modal;
            break;
        default:
            break;
    }

    return new_state;
};

export type ActionReduxState = {
    // TODO - type safe subcontracting modal
    subcontracting_modal: any => any,
    stock_forecast_tooltip: (
        state: StockForecastTooltipState,
        action: StockForecastTooltipActions
    ) => StockForecastTooltipState,
};

export type ReduxState = {
    subcontracting_modal: any, // TODO
    stock_status_filters: StockStatusTableFiltersState,
    persistent_filters: PersistentFiltersState,
    stock_forecast_tooltip: StockForecastTooltipState,
    translations_materials: TranslationsMaterialsState,
    ticketing: any, // TODO
};

export const reducers: ActionReduxState = {
    stock_status_filters: stockStatusFiltersReducer,
    resource_edit_filters: resourceEditFiltersReducer,
    stock_status_table_filters: stockStatusTableFiltersReducer,
    persistent_filters: persistentFiltersReducer,
    stock_forecast_tooltip: stockForecastTooltipReducer,
    subcontracting_modal: subcontractingModalReducer,
    translations_materials: translationsMaterialsReducer,
};
